import { Link, NavLink } from "react-router-dom";
import React from "react";
import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import AppContext from "../Context/Context";
import DragDrop from "../DragDrop/DragDrop";
import axiosAuth from "../Axios/Interceptors";
import LoadingAnimation from "../LoadingAnimation/LoadingAnimation";
export default function Header() {
  const [contactUsReason, setcontactUsReason] = useState([]);
  const [uploadFileList, setUploadFileList] = useState([]);
  const [triggerChild, setTriggerChild] = useState(false);
  const [isOkToGo, setIsOkToGo] = useState(false);
  const [loadingState, setLoadingState] = useState(false);

  const [ShowContact, SetShowContact] = useState(false);
  const ShowHideContact = () => {
    SetShowContact(!ShowContact);
  };

  const [contactObject, setcontactObject] = useState({
    Name: AppContext.LogInUserName,
    Email: "",
    Subject: "",
    Message: "",
    ContactReason: 0,
  });

  const [dragDropFeatures, setDragDropFeatures] = useState({
    ObjectID: 0,
    ObjectType: 1,
    MaxAllowedFiles: 4,
    UploadType: 1,
    FolderName: "Contact",
    PTUploadedFiles: [],
  });

  const [showInputSection, setShowInputSection] = useState(false);
  const [isInputSectionActive, setIsInputSectionActive] = useState(false);

  const [showReportsSection, setShowReportsSection] = useState(false);
  const [isReportsSectionActive, setIsReportsSectionActive] = useState(false);

  //Logout Menu
  const [showLogout, setshowLogout] = useState(false);
  const ShowHideLogoutMenu = () => {
    setshowLogout(!showLogout);
  };

  const [refresh, setRefresh] = useState(false);

  const [ShowFolder, SetShowFolder] = useState(false);
  const ShowHideFolder = () => {
    SetShowFolder(!ShowFolder);
  };

  function handleDragDropCallback(ChildData: any) {
    setUploadFileList(ChildData);
  }

  useEffect(() => {
    // getContactUsPageData();
  }, []);

  function getContactUsPageData() {
    let object = {} as any;
    object.appid = AppContext.App;
    axiosAuth
      .post(AppContext.CommAPI + "api/PTSupport/GetSupportTypeList", object)
      .then((response) => {
        if (response.data.Status === 1) {
          let l_response = response.data.Data[0];
          setcontactUsReason(l_response);
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  useEffect(() => {
    //checkValidation(false);
  }, [contactObject]);

  function checkValidation(takeAction: boolean) {
    if (
      contactObject.Name === "" ||
      contactObject.Email === "" ||
      contactObject.Message === "" ||
      contactObject.ContactReason === 0
    ) {
      if (takeAction) {
        alert("You need to select from all the information to continue.");
      }
      {
        setIsOkToGo(false);
      }
    } else {
      setIsOkToGo(true);
      if (takeAction) {
        SaveFiles();
      }
    }
  }

  function clearObject() {
    setcontactObject({
      Name: AppContext.LogInUserName,
      Email: "",
      Subject: "",
      Message: "",
      ContactReason: 0,
    });
  }

  function SaveFiles() {
    setLoadingState(true);
    if (uploadFileList && uploadFileList.length > 0) {
      let object = {} as any;
      object.typeid = 1;
      object.attachmenttype = dragDropFeatures.ObjectType;
      object.objectid = dragDropFeatures.ObjectID;
      object.applicationid = 1;
      object.filesdata = uploadFileList;
      axiosAuth
        .post(
          AppContext.FileManegmentAPI + "api/PTAttachment/SaveFilesData",
          object
        )
        .then((response) => {
          if (response.data.Status === 1) {
            setTriggerChild(!triggerChild);
            let l_response = response.data.Data;
            saveConactUsData(l_response);
          } else {
            AppContext.ShowNotification("error", response.data.Message);
          }
        })
        .catch((error) => {
          console.error("There was an error!", error);
        });
    } else {
      saveConactUsData([]);
    }
  }

  function saveConactUsData(p_S3UploadFileList: any) {
    setLoadingState(true);
    let object = {} as any;
    object.appid = AppContext.App;
    object.typeid = 1;
    object.ptsupporttypeid = contactObject.ContactReason;
    object.subject = "";
    object.firstname = contactObject.Name;
    object.firstname = "";
    object.email = contactObject.Email;
    object.contact = "";
    object.message = contactObject.Message;
    object.filesdata = p_S3UploadFileList;
    axiosAuth
      .post(AppContext.CommAPI + "api/PTSupport/SupportSubmitData", object)
      .then((response) => {
        if (response.data.Status === 1) {
          let l_response = response.data.Data;
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
        clearObject();
        SetShowContact(false);
        setLoadingState(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setLoadingState(false);
      });
  }

  useEffect(() => {
    setRefresh(!refresh);
  }, [AppContext.BPID]);

  useEffect(() => {
    setcontactObject((prevState: any) => ({
      ...prevState,
      Name: AppContext.LogInUserName,
    }));
    setRefresh(!refresh);
  }, [AppContext.LogInUserName]);

  const location = useLocation();
  useEffect(() => {
    //New Vehicles
  }, [location.pathname]);

  function LogOutUser() {
    AppContext.LogInUserName = "";
    AppContext.LogInUserImage = "";
    AppContext.LogInUserRole = "";
    window.location =
      "https://www.jlrmenabusinesstools.com/BusinessTools.aspx" as any;
  }

  function getUserLoggedOut() {
    let object = {} as any;
    axiosAuth
      .post(AppContext.AppAuthBaseURL + "api/SiteUser/GetUserLoggedOut", object)
      .then((response) => {})
      .catch((error) => {
        console.error("There was an error!", error);
        setLoadingState(false);
      });
  }

  return (
    <>
      <header className="header">
        {loadingState && <LoadingAnimation />}
        <div className="header--menu__left">
          <div className="header--left__logo">
            <img src="/images/logo-black.png" width="142px" height="30px" />
          </div>
          <div className="header--left__links">
            <a>Dashboard</a>
          </div>
        </div>
        <div className="header--menu__right">
          <div className="folder-inn">
            <a onClick={ShowHideFolder}>
              <img src="/images/folder.svg" width="25px" height="20" />
            </a>
            {ShowFolder && (
              <div className="floder-links">
                {AppContext.PermittedAppList &&
                  AppContext.PermittedAppList.map(
                    (Item: any, index: number) => (
                      <React.Fragment key={index}>
                        {AppContext.App === Item.AppID ? (
                          <a
                            className={"c-" + (index + 1)}
                            title={Item.AppDescription}
                          >
                            <img
                              src={Item.Img}
                              width="17px"
                              height="15px"
                              alt={Item.AppName}
                            />
                            <span>{Item.AppName}</span>
                          </a>
                        ) : (
                          <a
                            className={"c-" + (index + 1)}
                            title={Item.AppDescription}
                            href={Item.WebURL}
                          >
                            <img
                              src={Item.Img}
                              width="17px"
                              height="15px"
                              alt={Item.AppName}
                            />
                            <span>{Item.AppName}</span>
                          </a>
                        )}
                        <hr />
                      </React.Fragment>
                    )
                  )}
              </div>
            )}
          </div>
          <a
            onClick={() => {
              getContactUsPageData();
              ShowHideContact();
            }}
          >
            <img src="/images/help.svg" width="24px" height="24" />
          </a>
          {/* <a>
            <img src="/images/envelope.svg" width="32px" height="" />
          </a> */}
          <div className="log-drop">
            <a className="log-drop-a" onClick={ShowHideLogoutMenu}>
              <img
                src={AppContext.LogInUserImage}
                width="29px"
                height=""
                onError={({ currentTarget }) => {
                  currentTarget.onerror = null;
                  currentTarget.src = "/images/dummyuser.svg";
                }}
              />
              <span>{AppContext.LogInUserName}</span>
            </a>
            {showLogout && (
              <div className="logout-menu">
                <div className="log-user-image">
                  <img
                    src={AppContext.LogInUserImage}
                    width="29px"
                    height=""
                    onError={({ currentTarget }) => {
                      currentTarget.onerror = null;
                      currentTarget.src = "/images/dummyuser.svg";
                    }}
                  />
                </div>
                <div className="setting-log">
                  <a
                    href={
                      "https://www.jlrmenabusinesstools.com/Settings.aspx?app=" +
                      AppContext.App
                    }
                  >
                    Setting
                  </a>
                  <a onClick={() => LogOutUser()}>Sign out</a>
                </div>
              </div>
            )}
          </div>
        </div>
      </header>
      <menu className="menu">
        <div className="sub--menu--main">
          {AppContext.LogInUserRole === "Admin" && (
            <div className="subMenu">
              <NavLink
                to={"/input"}
                className={({ isActive }) => (isActive ? "active" : "")}
              >
                <div className="lm-img">
                  <img src="/images/lm1.svg" width="30px" height="30px" />
                </div>
                <span className="lm-spn">Input</span>
              </NavLink>
            </div>
          )}
          <div className="subMenu">
            <NavLink
              to={"/ytdleaguetabletrends"}
              className={({ isActive }) => (isActive ? "active" : "")}
            >
              <div className="lm-img">
                <img src="/images/lm2.svg" width="30px" height="30px" />
              </div>
              <span className="lm-spn">YTD Scoring Trends</span>
            </NavLink>
          </div>
          <div className="subMenu">
            <NavLink
              to={"/ytdleagueTable"}
              className={({ isActive }) => (isActive ? "active" : "")}
            >
              <div className="lm-img">
                <img src="/images/lm3.svg" width="30px" height="30px" />
              </div>
              <span className="lm-spn">YTD League Table</span>
            </NavLink>
          </div>
          <div className="subMenu">
            <NavLink
              to={"/monthleaguetable"}
              className={({ isActive }) => (isActive ? "active" : "")}
            >
              <div className="lm-img">
                <img src="/images/lm4.svg" width="30px" height="30px" />
              </div>
              <span className="lm-spn">Month League Table</span>
            </NavLink>
          </div>
          <div className="subMenu">
            <NavLink
              to={"/trendreport"}
              className={({ isActive }) => (isActive ? "active" : "")}
            >
              <div className="lm-img">
                <img src="/images/lm5.svg" width="30px" height="30px" />
              </div>
              <span className="lm-spn">Trends</span>
            </NavLink>
          </div>
          <div className="subMenu">
            <NavLink
              to="/networkscorecard"
              className={({ isActive }) => (isActive ? "active" : "")}
            >
              <div className="lm-img">
                <img src="/images/lm6.svg" width="30px" height="30px" />
              </div>
              <span className="lm-spn">Network Scorecard</span>
            </NavLink>
          </div>
          <div className="subMenu">
            <NavLink
              to="/salesscorecard"
              className={({ isActive }) => (isActive ? "active" : "")}
            >
              <div className="lm-img">
                <img src="/images/lm7.svg" width="30px" height="30px" />
              </div>
              <span className="lm-spn">Sales Scorecard</span>
            </NavLink>
          </div>
          <div className="subMenu">
            <NavLink
              to={"/aftersalesscorecard"}
              className={({ isActive }) => (isActive ? "active" : "")}
            >
              <div className="lm-img">
                <img src="/images/lm8.svg" width="30px" height="30px" />
              </div>
              <span className="lm-spn">Aftersales Scorecard</span>
            </NavLink>
          </div>
          <div className="subMenu">
            <NavLink
              to={"/retailerscorecard"}
              className={({ isActive }) => (isActive ? "active" : "")}
            >
              <div className="lm-img">
                <img src="/images/lm9.svg" width="30px" height="30px" />
              </div>
              <span className="lm-spn">Retailer Scorecard</span>
            </NavLink>
          </div>
          <div className="subMenu">
            <NavLink
              to={AppContext.OldAppLink + "/IBBTarget.aspx"}
              className={({ isActive }) => (isActive ? "active" : "")}
            >
              <div className="lm-img">
                <img src="/images/lm10.svg" width="25px" height="25px" />
              </div>
              <span className="lm-spn">IBB Targets</span>
            </NavLink>
          </div>
          {/* <div className="subMenu">
            <NavLink
              to={AppContext.OldAppLink + "/ReportActionPlan.aspx"}
              className={({ isActive }) => (isActive ? "active" : "")}
            >
              Action Plan
            </NavLink>
          </div> */}
        </div>
      </menu>
      {ShowContact && (
        <div className="popup-help">
          <div className="help-popup-display">
            <div className="help-inner">
              <div className="help-head">
                <h3>Contact Support</h3>
                <a className="close-help" onClick={ShowHideContact}>
                  <img
                    src="/images/close.svg"
                    width="15px"
                    height="15px"
                    alt="cross"
                  />
                </a>
              </div>
              <div className="help-row">
                <p>Name:</p>
                <input
                  value={contactObject.Name}
                  onChange={(e) =>
                    setcontactObject((prevState: any) => ({
                      ...prevState,
                      Name: e.target.value,
                    }))
                  }
                  placeholder="your name"
                  type="text"
                />
              </div>
              <div className="help-row">
                <p>Email:</p>
                <input
                  value={contactObject.Email}
                  onChange={(e) =>
                    setcontactObject((prevState: any) => ({
                      ...prevState,
                      Email: e.target.value,
                    }))
                  }
                  placeholder="your email address"
                  type="text"
                />
              </div>
              {/* <div className="help-row">
              <p>Subject:</p>
              <input
                value={contactObject.Subject}
                onChange={(e) =>
                  setcontactObject((prevState: any) => ({
                    ...prevState,
                    Subject: e.target.value,
                  }))
                }
                placeholder="Subject"
                type="text"
              />
            </div> */}
              <div className="help-row">
                <p>Type:</p>
                <select
                  className="input-field select-field"
                  defaultValue={contactObject.ContactReason}
                  onChange={(e) =>
                    setcontactObject((prevState: any) => ({
                      ...prevState,
                      ContactReason: e.target.value,
                    }))
                  }
                >
                  <option value="">Select</option>
                  {contactUsReason &&
                    contactUsReason.map((Item: any, index) => (
                      <option
                        value={Item.PTSupportTypeID}
                        key={Item.PTSupportTypeID}
                      >
                        {Item.Name}
                      </option>
                    ))}
                </select>
              </div>
              <div className="help-row help-area">
                <p>Message:</p>
                <textarea
                  value={contactObject.Message}
                  onChange={(e) =>
                    setcontactObject((prevState: any) => ({
                      ...prevState,
                      Message: e.target.value,
                    }))
                  }
                  placeholder="type your message..."
                ></textarea>
              </div>
              <div className="help-row help-area flex-start">
                <p>File/Image:</p>
                <div className="drad-drop">
                  <DragDrop
                    ParentFeatures={dragDropFeatures}
                    DragDropCallback={handleDragDropCallback}
                    TriggerChild={triggerChild}
                  />
                </div>
              </div>
              <div className="help-btns">
                <a onClick={() => checkValidation(true)}>Submit</a>
                <a onClick={ShowHideContact}>Cancel</a>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
